export default {
    'edit-account': 'Editar cuenta',
    'delete-account': 'Eliminar cuenta',

    'account-type': {
        title: 'Tipo de cuenta',
        main: 'Principal',
        sub: 'Sub',
    },
    
    'account-category': 'Clasificación de cuenta:',
    
    'final-accounts': {
        title: 'Cuenta final',
        operations: 'Explotación',
        trade: 'Mercancía',
        'gains-and-losses': 'Pérdidas y ganancias',
        budget: 'Balance general',
    },

    'max-credit-amount': 'Límite de crédito',
    'max-debit-amount': 'Límite de débito',
    'debt-is-forbidden': 'Prohibido de deuda',
    yes: 'Sí',
    no: 'No',

    'contect-info': {
        'phone-number': 'Fijo',
        'mobile-number': 'Móvil',
        email: 'Correo electronico',
        address: 'Dirección',
    },
    
    notes: 'Notas',
    
    'account-statement': 'Estado de cuenta',
    'breakdown-of-the-total-by-currency': 'Detalles de total por monedas',
    
    'delete-the-account': 'Eliminar cuenta',
    'are-you-sure-you-want-to-delete-the-account-$': '¿estas seguro de eliminar {accountName} cuenta?',

    headers: {
        'sum-debits': 'Débito total',
        'sum-credits': 'Crédito total',
        balance: 'Saldo',
        'equivalent-currency': 'Moneda equivalente',
        'currency-equivalent': 'Equivalente de moneda',
        'currencies-balances': 'Saldo de monedas',
    },

    'sum-currencies-result-headers': {
        'currency-debits': 'Débito en moneda extranjera',
        'currency-credits': 'Crédito en moneda extranjera',
    }
}